import DeleteSideBar from "./DeleteSideBar";

export default DeleteSideBar;
